import { makeStyles } from '@material-ui/core/styles';
import getCommonStyles from './_common';

const useContactStyles = makeStyles((theme) => ({
  ...getCommonStyles(theme),
  root: {
    ...getCommonStyles(theme).sectionContainer,
    marginBottom: theme.spacing(0),
    position: 'relative',
    background: 'transparent',
    padding: theme.spacing(12, 0, 12),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(8, 0, 8),
    },
  },
  sectionTitle: {
    ...getCommonStyles(theme).sectionTitle,
    fontFamily: '"vester-medium", "Montserrat", "Inter", sans-serif',
    fontWeight: 800,
    letterSpacing: '-0.02em',
    background: 'linear-gradient(135deg, #ffffff 0%, #cdfaf1 45%, #6fe9d6 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    fontSize: '3rem',
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
      textAlign: 'center',
    },
  },
  sectionDescription: {
    ...getCommonStyles(theme).sectionDescription,
    fontFamily: '"Montserrat", "Inter", "Segoe UI", sans-serif',
    color: '#b5c3d3',
    fontSize: '1.15rem',
    lineHeight: 1.9,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      fontSize: '1.05rem',
    },
  },
  contactRight: {
    position: 'relative',
    '& .content-bg': {
      [theme.breakpoints.up('md')]: {
        width: '100%',
        padding: theme.spacing(8, 0),
      },
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(6, 0),
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: '50%',
    },
  },
  contactLeft: {
    position: 'relative',
    '& .content-bg': {
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(6, 0),
        marginRight: '-40px',
        borderTopRightRadius: '10px',
        borderBottomRightRadius: '10px',
      },
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(6),
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(0),
      },
      position: 'relative',
    },
    '& .content-inner': {
      position: 'relative',
      zIndex: 5,
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(4, 6),
      },
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(6, 0),
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
    },
  },
}));
export default useContactStyles;
